<h2 mat-dialog-title>Select Subscription Plan</h2>
<mat-dialog-content>
  <div class="plan-select-wrapper">
    <app-plan-select [plans]="data.plans" [activePlanId]="activePlanId" (selected)="selectPlan($event)"></app-plan-select>

    @if (showPromoField) {
      <div class="promo-field">
        <div class="custom-icon-input-container">
          <input type="text" [formControl]="promoCode" placeholder="Promocode">
        </div>
      </div>
    }
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  @if (showCancel) {
    <button matButton [mat-dialog-close]="false">Cancel</button>
  }
  @if (showPromoField) {
    <button matButton (click)="save()" [disabled]="!planId || planId === ''">Apply</button>
  }

</mat-dialog-actions>
